/**
 * NC #827 — de soorten alternatieve namen, op één plek. De lijst zelf staat in
 * shared/nameTypes.json zodat de server (routes/people.js, routes/archives.js)
 * dezelfde whitelist gebruikt. Editor-opties, GEDCOM in/uit en het rapportfilter
 * lezen hier; een type toevoegen = de JSON + een vertaling (zie de test).
 */
import data from '../../shared/nameTypes.json';
import type { AlternativeNameType } from '../types.ts';

export const NAME_TYPES = data.types as AlternativeNameType[];

/** Wat een onbekend type wordt (server en GEDCOM-export). */
export const FALLBACK_NAME_TYPE = data.fallback as AlternativeNameType;

/** De types die het rapport als "ook bekend als" noemt. */
export const OOK_BEKEND_ALS_TYPES = new Set(data.ookBekendAls as AlternativeNameType[]);

export const isNameType = (v: unknown): v is AlternativeNameType =>
  typeof v === 'string' && (NAME_TYPES as string[]).includes(v);

/** i18n-sleutel van het label in de editor: 'aka' → 'nameTypeAka'. */
export const nameTypeLabelKey = (type: string): string =>
  `nameType${type.charAt(0).toUpperCase()}${type.slice(1)}`;
